<app-audio
    (audioPlayerReady)="onAudioPlayerReady($event)"
    class="audio"
    [audioMedia]="audioMedia"
    [gtmVideoJsInfo]="gtmVideoJsInfo"
    [muxData]="muxData"
>
</app-audio>
